import { Component, Input, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormBuilderHelper } from '../../../shared/helper';
import { BuilderService } from '../../../dnd/services/builder.service';
import * as SetValue from 'set-value';
import { BuilderField, BuilderControl } from '../../models/builder.model';
import { BuilderModel } from '../../models/builder.model';

@Component({
  selector: 'fb-control-properties-sidebar',
  templateUrl: './control-properties-sidebar.component.html',
  styleUrls: ['./control-properties-sidebar.component.scss'],
})
export class ControlPropertiesSidebarComponent implements AfterViewInit {
  private _controlProperties: any[] = [];
  private _activeModel: BuilderField;
  private _formBuilderHelper = new FormBuilderHelper();
  private _setValue = SetValue;

  set controlProperties(controlProperties: any) {
    if (controlProperties && JSON.stringify(controlProperties) !== JSON.stringify(this._controlProperties)) {
      this._controlProperties = controlProperties;
    }
  }

  private _activeControl: any;
  set activeControl(activeControl: any) {
    this._activeControl = activeControl;
    this.setupProperties(activeControl);
  }

  @Input() available: BuilderModel[] = [];

  private _model: any[] = [];
  @Input() set model(model: any) {
    if (model && JSON.stringify(model) !== JSON.stringify(this._model)) {
      this._model = model;
      this.propertiesForm['form'].patchValue({});
      this.updateForm();
    }
  }

  get model() {
    return this._model;
  }

  @Output('onTemplateAdded') templateEvent = new EventEmitter<any>();
  @ViewChild('propertiesForm', { static: false }) propertiesForm: FormGroup;

  private _backupFormValues: any = {};
  constructor(private builder: BuilderService) {}

  get readonlyProperties() {
    return ['code'];
  }

  get controlProperties() {
    return this._controlProperties;
  }

  get activeControl() {
    return this._activeControl;
  }

  get activeModel() {
    return this._activeModel || this._activeControl;
  }

  get canExport() {
    return FormBuilderHelper.IsSection(this.activeControl);
  }

  ngAfterViewInit() {
    this.builder.onFocus.subscribe((control: BuilderControl) => {
      this.activeControl = control;
    });
  }

  isReadonly(property) {
    return this.readonlyProperties.indexOf(property.name) !== -1;
  }

  export() {
    if (!this.activeControl || !this.canExport) {
      return;
    }
    this.templateEvent.emit(this.activeControl);
  }

  save() {
    if (!this.activeControl) {
      return;
    }
    const changes = this.propertiesForm['form'].value;

    this.updateForm();
    const alreadyExists = this.available && this.available.find(field => field.name === changes.referenceName);
    if (this._activeControl.name !== changes.referenceName && alreadyExists) {
      this.propertiesForm['form'].controls.referenceName.setValue(this._activeControl.name);
      alert('Cannot set already existing control reference name.');
      return;
    }
    const properties = [];
    Object.keys(this.controlProperties).forEach(key => properties.push(...this.controlProperties[key].properties));
    Object.keys(changes).forEach(key => {
      const property = properties.find(prop => prop.name === key);
      if (!property) {
        console.log('could not load property ', key);
        return;
      }
      const models = { control: this._activeControl, model: this._activeModel };
      const { target, path } = this._formBuilderHelper.parsePropertySource(models, property);
      this._setValue(target, path, changes[key]);
    });
    this.updateForm();
  }

  reset() {
    this.propertiesForm['form'].patchValue(this._backupFormValues);
    this.updateForm();
  }

  private setupProperties(control: BuilderField) {
    if (this.builder.availableModels) {
      this._activeModel = this.builder.availableModels.fieldCollection.find(field => field && field.name === control.name);
    }
    const properties = [];
    const controlMeta = Object.assign({}, control, this.activeModel);
    this._formBuilderHelper.propertiesByControlType(controlMeta).forEach(item => {
      if (!item) {
        console.log('emmm?!', control);
        return;
      }
      const res = Object.keys(item).map(key => {
        return {
          name: key,
          properties: this._formBuilderHelper.sanitizeProperties(item[key], this.propertiesForm, control, this.activeModel),
        };
      });
      properties.push(...res);
    });
    setTimeout(() => {
      this._backupFormValues = Object.freeze(this.propertiesForm.value);
    }, 1);
    this._controlProperties = properties;
    this.updateForm();
  }

  private updateForm() {
    setTimeout(() => {
      this.propertiesForm['form'].updateValueAndValidity();
    }, 0);
  }
}
